import { Button, Input, Loader, Modal, Notification, toaster } from "rsuite";
import Label from "../Label";
import Responsive from "../Responsive";
import { useEffect, useState } from "react";
import { APi } from "../../Api";
import Swal from "sweetalert2";
import Translation from "../../translation/translation";

const AddMontantModal = ({ open, handleClose, data, fetch }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState(data?.amount || 0);
  const [amountToBePaid, setAmountToBePaid] = useState(
    data?.amountToBePaid || 0
  );
  const [amountError, setAmountError] = useState(null);
  const [amountToBePaidError, setAmountToBePaidError] = useState(null);

  const validateInputs = () => {
    let isValid = true;
    if (isNaN(amount) || amount <= 0) {
      setAmountError("Le montant total doit être un nombre positif.");
      isValid = false;
    } else {
      setAmountError(null);
    }

    if (isNaN(amountToBePaid) || amountToBePaid < 0) {
      setAmountToBePaidError(
        "Le montant restant à payer doit être un nombre positif."
      );
      isValid = false;
    } else {
      setAmountToBePaidError(null);
    }

    return isValid;
  };

  const handleAmountChange = (value) => {
    const newValue = parseFloat(value);
    setAmount(newValue);
    if (isNaN(newValue) || newValue <= 0) {
      setAmountError("Le montant total doit être un nombre positif.");
    } else {
      setAmountError(null);
    }
  };

  const handleAmountToBePaidChange = (value) => {
    const newValue = parseFloat(value);
    setAmountToBePaid(newValue);
    if (isNaN(newValue) || newValue < 0) {
      setAmountToBePaidError(
        "Le montant restant à payer doit être un nombre positif."
      );
    } else {
      setAmountToBePaidError(null);
    }
  };

  const save = () => {
    if (!validateInputs()) return;

    setIsLoading(true);
    APi.createAPIEndpoint(
      APi.ENDPOINTS.Transaction + `/TransactionParent/UpdateAmount`
    )
      .patch({
        id: data.id,
        amount: amount,
        amountToBePaid: amountToBePaid,
      })
      .then((res) => {
        handleClose();
        fetch();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Element a été bien ajouté !",
          showConfirmButton: false,
          timer: 1500,
        });
        setIsLoading(false);
      })
      .catch((error) => {
        toaster.push(
          <Notification type="error" header={Translation.errorHeader} closable>
            {error?.response?.data?.title ||
              error?.response?.data?.message ||
              Translation.error}
          </Notification>,
          { placement: "topEnd" }
        );
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setAmount(data?.amount || 0);
    setAmountToBePaid(data?.amountToBePaid || 0);
  }, [data]);

  return (
    <Modal
      size="sm"
      overflow={false}
      style={{
        maxHeight: "calc(100vh - 50px)",
        overflow: "auto",
        width: "40vw",
        margin: "auto",
      }}
      open={open}
      onClose={handleClose}
    >
      <Modal.Header>Modifier montnat total</Modal.Header>
      <Modal.Body>
        <div style={{ maxHeight: "calc(100vh - 240px)", overflow: "auto" }}>
          <Responsive m={6} l={6} xl={6} className="p-10">
            <Label required>Totale :</Label>
            <Input
              type="number"
              step="0.1"
              value={amount}
              onChange={handleAmountChange}
              aria-label="Montant total"
              isInvalid={!!amountError}
            />
            {amountError && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {amountError}
              </div>
            )}
          </Responsive>
          <Responsive m={6} l={6} xl={6} className="p-10">
            <Label required>Reste à payer :</Label>
            <Input
              type="number"
              step="0.1"
              value={amountToBePaid}
              onChange={handleAmountToBePaidChange}
              aria-label="Montant restant à payer"
              isInvalid={!!amountToBePaidError}
            />
            {amountToBePaidError && (
              <div style={{ color: "red", fontSize: "12px" }}>
                {amountToBePaidError}
              </div>
            )}
          </Responsive>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} appearance="subtle">
          Annuler
        </Button>
        <Button
          onClick={save}
          appearance="primary"
          disabled={data?.paymentStatus === 1 || isLoading}
        >
          {isLoading ? <Loader size="sm" /> : "Enregistrer"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddMontantModal;
